import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TableIconText, TableAlign } from '../../../../../../global';
import { MatTooltip } from '@angular/material/tooltip';
import { LoaderComponent } from '../../../../loader/loader.component';
import { SvgIconComponent } from '../../../../svg-icon/svg-icon.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'slm-table-icon-text',
    template: `
    @if (data) {
      <div [matTooltip]="tooltip | translate" class="w-100 block flex flex-{{ align || 'center' }} flex-items-center">
        @if (data.loading) {
          <slm-loader [diameter]="20" class="block m-auto mr-1"></slm-loader>
        } @else if (data.icon) {
          <slm-svg-icon [color]="data.color" [icon]="data.icon" class="mr-1"></slm-svg-icon>
        }

        @if (data.label) {
          <h5 class="m-0 txt-start-i w-auto-i">
            {{ data.label | translate }}
          </h5>
        }

        @if (data?.notification?.icon) {
          <div
            class="ml-1 size-1 radius-infinite color-white flex flex-center flex-items-center"
            [matTooltip]="data.notification.label | translate"
            [style.backgroundColor]="data.notification.color"
          >
            <slm-svg-icon
              [icon]="data?.notification?.icon"
              class="fill-white block size-16 w-16pxi h-16pxi"
              size="16px"
            ></slm-svg-icon>
          </div>
        }
      </div>
    } @else {
      <span class="w-100 block txt-center-i">--</span>
    }
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatTooltip,
        LoaderComponent,
        SvgIconComponent,
        TranslatePipe,
    ],
})
export class TableIconTextComponent {
  @Input() data: TableIconText = null;
  @Input() tooltip: string = null;
  @Input() align: TableAlign = TableAlign.CENTER;
}
